import React from 'react';
import PageHelmet from './PageHelmet';

/** SEO meta for private/transactional pages that should not appear in search results. */
export default function NoIndexHelmet({ title, path = '/' }) {
  return (
    <PageHelmet
      title={title}
      description="Pack My Cart — online grocery shopping in Jamaica."
      path={path}
      robots="noindex, nofollow"
    />
  );
}
